import type { SVGProps } from "react";
export const ArrowNorthWest = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M14 4.5V6H7.05375L18.5 17.4462L17.4462 18.5L6 7.05375V14H4.5V4.5H14Z"
			fill="currentColor"
		/>
	</svg>
);
